export const NEXT_SELLER_SOURCES = [
    { id: "pignoramenti_pre_asta", label: "Pignoramenti pre-asta", priority: "P1" },
    { id: "crisi_dismissioni", label: "Crisi aziendali e dismissioni", priority: "P2" },
    { id: "privati_diretti", label: "Privati diretti", priority: "P3" },
    { id: "portali_commerciali", label: "Portali commerciali" },
    { id: "aste_giudiziarie_ufficiali", label: "Aste giudiziarie ufficiali" },
    { id: "tribunali_cancellerie", label: "Tribunali e cancellerie" },
    { id: "gazzetta_bollettini", label: "Gazzetta Ufficiale e bollettini regionali" },
    { id: "comuni_enti_pubblici", label: "Comuni e enti pubblici" },
    { id: "successioni_pratiche_notarili", label: "Successioni e pratiche notarili" },
];

export const DEFAULT_NEXT_SELLER_SOURCES = NEXT_SELLER_SOURCES
    .filter((source) => !["portali_commerciali", "privati_diretti"].includes(source.id))
    .map((source) => source.id);

export const sourceLabel = (sourceId) => NEXT_SELLER_SOURCES.find((source) => source.id === sourceId)?.label || "Fonte pubblica";